import { useState } from "react";
import { faPhone, faUser, faFilePdf, faCashRegister, faReceipt, faUserDoctor, faHospital, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formatBirth, formatCPF, formatDateDDMMYYYY, formatDateDDMMYYYYHHMM, formatPhone } from "../utils/formats";
import AttendanceStatusModal from "./AttendanceStatusModal";
import Globals from "../Globals";
import AttendancePaymentModal from "./AttendancePaymentModal";

export default function AttendanceFullCard({ attendance, onAttendanceUpdate }) {
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [currentAttendance, setCurrentAttendance] = useState(attendance);

  const getStatusInfo = (status) => {
    switch (status) {
      case '0':
        return { text: 'em aberto', colorClass: 'delivering' };
      case '1':
        return { text: 'orçamento enviado', colorClass: 'bg-info' };
      case '2':
        return { text: 'vendido', colorClass: 'bg-success' };
      case '3':
        return { text: 'negado', colorClass: 'bg-danger' };
      default:
        return { text: 'desconhecido', colorClass: 'bg-secondary' };
    }
  };

  const openStatusModal = (e, budgetStatus) => {
    e.preventDefault();
    e.stopPropagation();
  
    if(budgetStatus !== '0' && budgetStatus !== '1'){
      setStatusModalOpen(true);
    }
  };
  

  const openPaymentModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setPaymentModalOpen(true);
  };

  const handleStatusChange = (attendanceId, newStatus) => {
    // Atualiza o estado local
    setCurrentAttendance(prev => ({
      ...prev,
      budget_status: newStatus
    }));

    // Notifica o componente pai sobre a atualização (se necessário)
    if (onAttendanceUpdate) {
      onAttendanceUpdate(attendanceId, newStatus);
    }
  };

  const openPdfFile = (file) => {
    const fileUrl = Globals.BASE_URL + '/storage/' + file;

    return (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.open(fileUrl, '_blank');
    }
  }

  return (
    <Col>
      <Link
        to={`/sales/${attendance.attendance_id}`}
        state={{
          customer: attendance.name,
          phone: attendance.mobile,
          professional: attendance.professional_name,
          dateScheduling: formatDateDDMMYYYY(attendance.date_scheduling),
          shopper: attendance.shopper_id,
          scheduling: attendance.scheduling_id,
          requisition: attendance.requisition_id,
          attendance_id: attendance.attendance_id
        }}
        className="text-decoration-none">
        <Card className="h-100 primary-border border-hover-success">
          <Card.Body>
            <div className="d-flex align-items-start">

              <div className="flex-grow-1">
                <Row className="g-2 align-items-center">
                  <div style={{ width: '80px' }}>
                    <div
                      className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white fw-bold"
                      style={{ width: '50px', height: '50px', fontSize: '1.2rem' }}
                    >
                      <FontAwesomeIcon icon={faUser} size="xl" />
                    </div>
                  </div>

                  <Col md={4} className="d-flex flex-column gap-2">
                    <h5 className="card-title fw-semibold">{attendance.name}</h5>
                    <span>CPF: {formatCPF(attendance.cpf)}</span>
                    <span>Nascimento: {formatBirth(attendance.birth)}</span>
                    <div className="d-flex align-items-center">
                      <FontAwesomeIcon icon={faPhone} className="me-1" style={{ fontSize: '0.75rem' }} />
                      <small>{formatPhone(attendance.mobile)}</small>
                    </div>
                  </Col>

                  <Col md={3} className="d-flex flex-column gap-3">
                    <span><FontAwesomeIcon icon={faUserDoctor} /> {attendance.professional_name}</span>
                    <div className="fw-semibold">
                      <FontAwesomeIcon icon={faHospital} /> {attendance.shopper_name}
                    </div>
                    <span><FontAwesomeIcon icon={faCalendar} /> Data da solicitação: {formatDateDDMMYYYYHHMM(attendance.date_scheduling)}</span>
                  </Col>

                  {/* <Col md={2}>
                  </Col> */}

                  <div style={{ width: '12.5%' }}>
                    <span
                      style={{ marginBottom: 10, marginTop: 10 }}
                      className={`status-info text-white ${getStatusInfo(attendance.budget_status).colorClass}`}
                      onClick={(e) => openStatusModal(e, attendance.budget_status)}
                      title="Clique para alterar o status"
                      onMouseEnter={(e) => {
                        e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.boxShadow = 'none';
                      }}
                    >
                      {getStatusInfo(attendance.budget_status).text}
                    </span>

                  </div>

                  {
                    attendance.budget_pdf_url && (
                      <>
                        <div style={{ width: '7.5%' }}>
                          <FontAwesomeIcon
                            icon={faCashRegister}
                            size="2x"
                            className="me-1 primary-color"
                            title="Registrar pagamento"
                            onClick={openPaymentModal}
                            style={{ transition: 'transform 0.2s' }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                          />
                        </div>

                        <div style={{ width: '7.5%' }}>
                          <FontAwesomeIcon
                            icon={faFilePdf}
                            size="2x"
                            className="me-1 primary-color"
                            title="Abrir PDF do orçamento"
                            onClick={openPdfFile(attendance.budget_pdf_url)}
                            style={{ transition: 'transform 0.2s' }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                          />
                        </div>
                      </>
                    )
                  }

                  {
                    attendance.image_recipt && (
                      <div style={{ width: '7.5%' }}>
                        <FontAwesomeIcon
                          icon={faReceipt}
                          size="2x"
                          className="me-1 primary-color"
                          title="Abrir recibo do orçamento"
                          onClick={openPdfFile(attendance.image_recipt)}
                          style={{ transition: 'transform 0.2s' }}
                          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                        />
                      </div>
                    )
                  }
                </Row>
              </div>
            </div>

          </Card.Body>
        </Card>
      </Link>

      <AttendanceStatusModal
        show={statusModalOpen}
        onHide={() => setStatusModalOpen(false)}
        attendance={currentAttendance}
        onStatusChange={handleStatusChange}
      />

      <AttendancePaymentModal
        show={paymentModalOpen}
        attendance={currentAttendance}
        onHide={() => setPaymentModalOpen(false)}
      />
    </Col>
  )
}